import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './dark-theme.css'
import { Taskpane } from './taskpane/Taskpane.jsx'

/**
 * Bootstrap des Outlook-Add-in Task Panes.
 *
 * Office.js wird in index.html geladen und ruft Office.onReady auf, sobald
 * der Host-Kontext bereit ist. Wir mounten React erst danach — vorher sind
 * Office.context und Office.context.mailbox noch nicht garantiert verfügbar.
 *
 * onReady wird auch dann aufgerufen, wenn das Add-in außerhalb von Outlook
 * geöffnet wird (z.B. Direktaufruf von https://localhost:3000 im Browser),
 * dann ist `info.host` aber `null`. Das Taskpane-Component muss damit
 * umgehen und einen Standalone-Mode anzeigen.
 */

const rootEl = document.getElementById('root')
const root = createRoot(rootEl)

/**
 * #1088: Setzt CSS-Variablen --fd-visible-width und --fd-visible-height auf
 * die tatsaechliche sichtbare Viewport-Groesse. Hintergrund:
 *
 *   - Outlook (besonders Mobile/Popup) gibt dem Add-in-iframe oft eine
 *     groessere Breite als der sichtbare Bereich. Folge: alles rechts vom
 *     sichtbaren Rand (inkl. Scrollbar) wird abgeschnitten.
 *   - Auf der Hoehe das gleiche Problem: 100vh in CSS ist die iframe-
 *     Viewport-Hoehe, aber wenn der Mobile-Host das iframe nicht korrekt
 *     dimensioniert, ist 100vh entweder zu klein (Inhalt unter dem Fold
 *     verschwindet) oder die Hoehe ist sehr gross (Scrollbar offscreen).
 *
 * window.innerWidth/innerHeight liefern die ECHT sichtbare Viewport-
 * Groesse des iframe — und das nutzen wir, statt der Element-Dimensionen
 * zu vertrauen. Bei Resize aktualisieren (Pane-Drag, Rotation).
 */
/**
 * #1088: Setzt CSS-Variablen --fd-visible-width und --fd-visible-height auf
 * die tatsaechliche sichtbare Viewport-Groesse. Hintergrund:
 *
 *   - Outlook (besonders Mobile/Popup) gibt dem Add-in-iframe oft eine
 *     groessere Breite als der sichtbare Bereich. Folge: alles rechts vom
 *     sichtbaren Rand (inkl. Scrollbar) wird abgeschnitten.
 *   - Auf der Hoehe das gleiche Problem: 100vh in CSS ist die iframe-
 *     Viewport-Hoehe, aber wenn der Mobile-Host das iframe nicht korrekt
 *     dimensioniert, ist 100vh entweder zu klein oder die Hoehe ist sehr
 *     gross (Scrollbar offscreen).
 *
 * window.innerWidth/innerHeight liefern die ECHT sichtbare Viewport-
 * Groesse des iframe — und das nutzen wir, statt der Element-Dimensionen
 * zu vertrauen. Bei Resize aktualisieren (Pane-Drag, Rotation).
 */
function syncVisibleViewport() {
  const w = window.innerWidth
  const h = window.innerHeight
  document.documentElement.style.setProperty('--fd-visible-width', w + 'px')
  document.documentElement.style.setProperty('--fd-visible-height', h + 'px')
}
syncVisibleViewport()
window.addEventListener('resize', syncVisibleViewport)
// Nochmal nachfeuern fuer den Fall dass Shell beim ersten Run noch nicht
// gemountet war oder der Host das Viewport spaeter aendert.
setTimeout(syncVisibleViewport, 500)
setTimeout(syncVisibleViewport, 2000)

if (typeof Office !== 'undefined' && Office.onReady) {
  Office.onReady((info) => {
    root.render(
      <StrictMode>
        <Taskpane officeInfo={info} />
      </StrictMode>,
    )
  })
} else {
  // Kein Office-Host — z.B. Direktaufruf im Browser ohne Office.js.
  // Sollte in Praxis nicht passieren, weil office.js in index.html geladen
  // wird; defensives Fallback für unerwartete Lade-Reihenfolgen.
  root.render(
    <StrictMode>
      <Taskpane officeInfo={null} />
    </StrictMode>,
  )
}
